import React from 'react';
import UnitsPage from './UnitsPage';

const UnidadesGasPage = () => {
  return <UnitsPage tipoUnidad="unidad de gasolina" title="Unidad de gasolina" />;
};

export default UnidadesGasPage;
